import type { ISecureStorage } from '@erp/native/interfaces';

/**
 * Web fallback — `localStorage` is the only option in a browser without
 * an extension, but tokens written here are exposed to anyone with DOM
 * access (XSS, devtools). Supabase already does this in its default
 * `localStorage` flow, so we are not making it worse.
 *
 * On desktop, `tauri-adapter` swaps in Stronghold backed by the OS
 * keychain — that's where the security upgrade actually lives.
 */
const PREFIX = 'erp.secure.';

export function createWebSecureStorage(): ISecureStorage {
  return {
    async get(key) {
      try {
        return window.localStorage.getItem(PREFIX + key);
      } catch {
        return null;
      }
    },
    async set(key, value) {
      window.localStorage.setItem(PREFIX + key, value);
    },
    async remove(key) {
      window.localStorage.removeItem(PREFIX + key);
    },
    async clear() {
      const toRemove: string[] = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const k = window.localStorage.key(i);
        if (k && k.startsWith(PREFIX)) toRemove.push(k);
      }
      toRemove.forEach((k) => window.localStorage.removeItem(k));
    },
    async isAvailable() {
      try {
        const probe = '__erp_probe__';
        window.localStorage.setItem(probe, probe);
        window.localStorage.removeItem(probe);
        return true;
      } catch {
        return false;
      }
    },
  };
}
